import { Box } from "@mui/material";
import { PartLibTable } from "./PartLibTable";

export function PartLib() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", p: 2, gap: 2, bgcolor: "background.default" }}>
      <PartLibTable />
    </Box>
  );
}
